export type KeywordSearchContentClass = 'video' | 'audio' | 'image';

/** Minimal shape we need off a search result; real `SearchResult`s satisfy it. */
type ResultLike = { contentClass: string };

const KEYWORD_SEARCH_ROUTES: Record<KeywordSearchContentClass, string> = {
    video: '/video/search',
    audio: '/audio/search',
    image: '/images/search',
};

/**
 * Pick the keyword-search media type for the latest conversational search
 * results. Results that are all one supported media type route to that type's
 * page; anything else — a mixed cross-asset turn, no results, or an unsupported
 * class — defaults to video.
 */
export function resolveKeywordSearchContentClass(results: readonly ResultLike[]): KeywordSearchContentClass {
    const [first] = results;
    if (first === undefined || !isKeywordSearchContentClass(first.contentClass)) {
        return 'video';
    }
    const isSingleClass = results.every((result) => result.contentClass === first.contentClass);
    return isSingleClass ? first.contentClass : 'video';
}

function isKeywordSearchContentClass(contentClass: string): contentClass is KeywordSearchContentClass {
    return Object.hasOwn(KEYWORD_SEARCH_ROUTES, contentClass);
}

export function getKeywordSearchUrl(results: readonly ResultLike[]): string {
    return KEYWORD_SEARCH_ROUTES[resolveKeywordSearchContentClass(results)];
}

/** Keyword-search page (as an empty search) for an explicitly known media type. */
export function getKeywordSearchUrlForContentClass(contentClass: KeywordSearchContentClass): string {
    return KEYWORD_SEARCH_ROUTES[contentClass];
}
